import React, { useContext } from 'react'
import { Loader, Notifier, SuccessNotif } from 'src/component'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { Design } from 'src/model'

export const Status: React.FC<any> = () => {
    const {info: {institutionData}} = useContext(AppInfoContext)
    const { visibility: { isLoading, notification } } = useContext(VisibilityContext)

    return (
        <>
            { isLoading ? <Loader /> : null }
            { (notification.status && notification.type === 'success' && institutionData.design === Design.DESIGN_2 && notification.hasD2) ?
                <SuccessNotif />
               :
                <Notifier />
            }
        </>
    )
}